
import { useAuthCallback } from "@/hooks/useAuthCallback";
import PasswordResetForm from "@/components/auth/PasswordResetForm";
import VerificationStatus from "@/components/auth/VerificationStatus";

const AuthCallback = () => {
  const { isLoading, verificationStatus, showPasswordForm } = useAuthCallback();

  // Render password reset form
  if (showPasswordForm) {
    return <PasswordResetForm />;
  }

  // Render verification status
  return (
    <VerificationStatus 
      isLoading={isLoading} 
      verificationStatus={verificationStatus} 
    />
  );
};

export default AuthCallback;
